const fetchWrapper = {
  get: async (url) => {
    return makeRequest(url, { method: 'GET' });
  },
  post: async (url, body) => {
    return makeRequest(url, {
      method: 'POST',
      body: JSON.stringify(body)
    });
  },
  postFile: async (url, formData) => {
    return makeRequest(url, {
      method: 'POST',
      body: formData
    });
  },
  put: async (url, body) => {
    return makeRequest(url, {
      method: 'PUT',
      body: JSON.stringify(body)
    });
  },
  delete: async (url) => {
    return makeRequest(url, { method: 'DELETE' });
  }
};

async function makeRequest(url, options) {
  const token = localStorage.getItem('access_token');

  const headers = {
    ...(options.method !== 'POST' || typeof options.body !== 'object' ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };

  const requestOptions = {
    ...options,
    headers
  };

  const response = await fetch(addHost(url), requestOptions);
  return handleResponse(response);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (response.status === 401) {
      //return to login if it is 401 
      goToLogin();
      throw new Error(data.message || 'Unauthorized');
    }
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      throw new Error(error);
    }
    return data;
  });
}

function addHost(url) {

  if (process.env.NODE_ENV === 'development') {
    return url;
  }

  if (window.location.href.indexOf('https://cms.uat.stack-ez.com') !== -1 || window.location.href.indexOf('d3d6id8xtg17ty.cloudfront.net') !== -1) {
    //uat
    return 'https://cms.uat.stack-ez.com' + url;
  } else if (window.location.href.indexOf('d3470v2pw42f2u.cloudfront.net') !== -1) {
    //dev
    return 'https://d3470v2pw42f2u.cloudfront.net' + url;
  } else {
    //prod
    return 'https://cms.stackez.com' + url;
  }
}



function goToLogin() {
  localStorage.removeItem('access_token');
  window.location.href = '/login';
}

export default fetchWrapper;    